import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ApiRouteSubWorkOrderService } from 'src/app/api/elite/routes/sub-work-order.service';
import { Department } from 'src/app/api/elite/types/department.js';
import { QualityControlWorkOrder } from '../../../common/quality-control/model/work-order-qc.ts';
import { QualityControlSubWorkOrder } from '../../../common/quality-control/model/sub-work-order-qc.ts';
import { ApiRouteInjectionMoldingService } from '../../../api/elite/routes/injection-molding.service';
import { InspectionApiDto } from '../../../api/elite/dto/inspection.dto';
import { ApiRouteInspectionService } from '../../../api/elite/routes/inspection.service';
import { SchedulerSubWorkOrder } from '../../../common/scheduler/models/sub-work-order';

@Injectable({
  providedIn: 'root',
})
export abstract class QualityControlViewApiService {
  protected readonly subWorkOrderApiRoute = inject(ApiRouteSubWorkOrderService);
  protected readonly apiInjectionMoldingRouter = inject(
    ApiRouteInjectionMoldingService
  );
  protected readonly apiInspectionRouter = inject(ApiRouteInspectionService);

  abstract getDepartment(): Observable<Department>;

  data(): Observable<QualityControlWorkOrder[]> {
    return this.getDepartment().pipe(
      switchMap((dep) => {
        const query = new URLSearchParams({
          stage: 'Quality Control',
          quantityOut: 'true',
          includeInspection: 'true',
        });
        return this.subWorkOrderApiRoute
          .getByTypeAndStage(dep.id, query.toString())
          .pipe(
            map((res: SchedulerSubWorkOrder[]) => {
              return this.transformItemToWorkOrder(res);
            })
          );
      })
    );
  }

  protected transformItemToWorkOrder(
    res: SchedulerSubWorkOrder[]
  ): QualityControlWorkOrder[] {
    return res.map((el) => QualityControlSubWorkOrder.transformToWorkOrder(el));
  }

  createInspection(
    body: InspectionApiDto['create']['body']
  ): Observable<InspectionApiDto['create']['result']> {
    return this.apiInspectionRouter.createInspection(body);
  }

  finishInspection(
    inspectionId: number,
    notes?: string,
    body?: InspectionApiDto['finish']['body']
  ): Observable<InspectionApiDto['finish']['result']> {
    return this.apiInspectionRouter.finishInspection(inspectionId, notes, body);
  }
}
